import React, { useEffect, useMemo, useState } from 'react';
import Main from '../Main';
import { Col, Dropdown, Form, Row } from 'react-bootstrap';
import searchIcon from '../../assets/images/Dashboard/search-icon.svg'
import calendar from '../../assets/images/Dashboard/calendar-icon.svg'
import columnFilter from '../../assets/images/CustomerManagement/columnFilter.svg'
import valueFilter from '../../assets/images/CustomerManagement/valueFilter.svg'
import '../../assets/css/dashboard.scss'
import '../../assets/css/customermanagement.scss'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import SbCancelBtn, { SbAddBtn, SbFilterBtn } from '../Buttons/Buttons';
import Select from 'react-select';
import AuditTrialTable from './AuditTrialTable';
import Download from '../MainSection/Download/Download';
import ExceptionLogTable from './ExceptionLogTable';
import ViewExceptionModal from './ViewExceptionModal';
import { useDispatch, useSelector } from 'react-redux';
import { loadExceptionLoggingData, loadSingleExceptionLoggingData } from '../../redux/action';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { Document, Packer, Table, TableRow, TableCell, Paragraph } from "docx";
import { saveAs } from "file-saver";
import * as XLSX from 'xlsx';
import { Highlighter, Typeahead } from 'react-bootstrap-typeahead';
import { formatDate } from '../DateTimeUtils';

const statusOptions = [
    { value: "All", label: "All" },
    { value: "Pending", label: "Pending" },
    { value: "In-Process", label: "In-Process" },
    { value: "Resolved", label: "Resolved" },
    { value: "Re-Open", label: "Re-Open" },
    { value: "Cancel", label: "Cancel" },
]
const ExceptionLog = () => {

    let dispatch = useDispatch();

    const { getExceptionLoggingData = [] } = useSelector((state) => state.data);
    const { getSingleExceptionLoggingData } = useSelector((state) => state.data);

    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showFilterMenu, setShowFilterMenu] = useState(false);
    const [showColumnFilterModal, setShowColumnFilterModal] = useState(false);
    const [showValueFilterModal, setShowValueFilterModal] = useState(false);
    const [showCustomerViewDetails, setShowCustomerViewDetails] = useState(false);
    const [businessUnitModal, setBusinessUnitModal] = useState(false);
    const [branchPlantModal, setBranchPlantModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const [selected, setSelected] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [searchQuery, setSearchQuery] = useState('');

    // useEffect(() => {
    //     dispatch(loadExceptionLoggingData(setLoading))
    // }, [])


    useEffect(() => {
        dispatch(loadExceptionLoggingData(fromDate, toDate, searchQuery, setLoading));
    }, [dispatch, fromDate, toDate, searchQuery]);

    const toggleFilterMenu = () => {
        setShowFilterMenu(!showFilterMenu);
    };

    const handleFromDateChange = (date) => {
        setFromDate(date);
    };

    const handleToDateChange = (date) => {
        setToDate(date);
    };

    const [exceptionID, setExceptionID] = useState("")
    const handleOpenModal = (exceptionId) => {
        setIsModalOpen(true);
        if (exceptionId) {
            dispatch(loadSingleExceptionLoggingData(exceptionId))
            setExceptionID(exceptionId);
        } else {
            setExceptionID("");
        }
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };
    const handleOpenColumnFilterModal = () => {
        setShowFilterMenu(false);
        setShowColumnFilterModal(true);
    };

    const handleCloseColumnFilterModal = () => {
        setShowColumnFilterModal(false);
    };
    const handleOpenValueFilterModal = () => {
        setShowFilterMenu(false);
        setShowValueFilterModal(true);
    };

    const handleCloseValueFilterModal = () => {
        setShowValueFilterModal(false);
    };

    const handleViewDetails = () => {
        setShowCustomerViewDetails(!showCustomerViewDetails);
    }

    // Search trigger function
    const handleSearchClick = () => {
        setSearchQuery(searchText); // Set the search query only when the button is clicked
    };

    // Handle the search input change (when selecting an item from Typeahead)
    const handleSearchChange = (selected) => {
        const query = selected.length ? selected[0] : ''; // Get the selected query or an empty string
        const selectedExceptionId = query.ExceptionID;
        setSearchQuery(selectedExceptionId); // Update searchQuery
        setSearchText(query); // Update searchText
        setSelected(selected);
    };

    const handleClearFilters = () => {
        setFromDate(null);
        setToDate(null);
        setSearchQuery("");
        setSearchText("");
        setSelected([]);
    }

    // Function to handle Excel download
    const handleDownloadExcel = () => {
        // Prepare data to be written to Excel (complainEscalationData)
        const dataToExport = getExceptionLoggingData?.map(item => ({
            "EXCEPTION SEVERITY": item.ExceptionSeverity || "NA",
            "EXCEPTION DATE": item.ExceptionDate || "NA",
            "EXCEPTION MESSAGE": item.ExceptionMessage || "NA",
            "EXCEPTION SOURCE": item.ExceptionSource || "NA",
            "EXCEPTION PROCEDURE": item.ExceptionProcedure || "NA",
        })) || [];

        // Create a new workbook
        const ws = XLSX.utils.json_to_sheet(dataToExport);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "ExceptionLog");

        // Generate Excel file and trigger the download
        XLSX.writeFile(wb, 'exception_Log.xlsx');
    };

    const handleDownloadImage = async () => {
        if (!getExceptionLoggingData || getExceptionLoggingData.length === 0) {
            console.error("No data available for exporting.");
            alert("No data to export!");
            return;
        }

        const maxRowsPerPage = 50; // Max rows per image
        const headers = ["EXCEPTION SEVERITY", "EXCEPTION DATE", "EXCEPTION MESSAGE", "EXCEPTION SOURCE", "EXCEPTION PROCEDURE"];

        // Function to generate and download an image for a given set of rows
        const capturePage = async (pageNumber, rows) => {
            const printContainer = document.createElement("div");
            printContainer.style.position = "absolute";
            printContainer.style.left = "-9999px";
            printContainer.style.backgroundColor = "#fff";
            printContainer.style.padding = "20px";
            printContainer.style.border = "1px solid #ccc";
            printContainer.style.fontFamily = "Arial, sans-serif";

            printContainer.innerHTML = `
                <h2 style="text-align: center;">Exception Logging Report - Page ${pageNumber}</h2>
                <table border="1" style="border-collapse: collapse; width: 100%; text-align: left;">
                    <thead>
                        <tr>
                            ${headers.map(header => `<th style="padding: 10px; background-color: #f2f2f2;">${header}</th>`).join('')}
                        </tr>
                    </thead>
                    <tbody>
                        ${rows.map(row => `
                            <tr>
                                ${row.map(cell => `<td style="padding: 10px;">${cell}</td>`).join('')}
                            </tr>
                        `).join('')}
                    </tbody>
                </table>
            `;

            document.body.appendChild(printContainer);

            try {
                const canvas = await html2canvas(printContainer, {
                    scale: 2,
                    useCORS: true,
                    backgroundColor: "#fff",
                });

                document.body.removeChild(printContainer);

                const blob = await new Promise(resolve => canvas.toBlob(resolve, "image/png"));
                if (!blob) {
                    console.error("Image generation failed.");
                    alert("Failed to generate image.");
                    return;
                }

                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = `exception_log_page_${pageNumber}.png`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } catch (err) {
                console.error("Error capturing image:", err);
                alert("Error generating image. Try again.");
                document.body.removeChild(printContainer);
            }
        };

        // Split data into pages and capture each page separately
        const totalPages = Math.ceil(getExceptionLoggingData.length / maxRowsPerPage);
        for (let i = 0; i < totalPages; i++) {
            const start = i * maxRowsPerPage;
            const end = start + maxRowsPerPage;
            const rows = getExceptionLoggingData.slice(start, end).map(item => [
                item.ExceptionSeverity || "NA",
                item.ExceptionDate || "NA",
                item.ExceptionMessage || "NA",
                item.ExceptionSource || "NA",
                item.ExceptionProcedure || "NA",
            ]);

            await capturePage(i + 1, rows);
        }
    };

    // Function to handle PDF download
    const handleDownloadPDF = () => {
        const doc = new jsPDF({ orientation: 'landscape' }); // Landscape for more width

        // Title
        doc.setFontSize(18);
        doc.text("Activity Log Data", 14, 20);

        const dataToExport = getExceptionLoggingData?.map(item => ([
            item.ExceptionSeverity || "NA",
            item.ExceptionDate || "NA",
            item.ExceptionMessage || "NA",
            item.ExceptionSource || "NA",
            item.ExceptionProcedure || "NA",
        ])) || [];

        const columns = [
            { title: "EXCEPTION SEVERITY", dataKey: "exceptionSeverity" },
            { title: "EXCEPTION DATE", dataKey: "exceptionDate" },
            { title: "EXCEPTION MESSAGE", dataKey: "exceptionMessage" },
            { title: "EXCEPTION SOURCE", dataKey: "exceptionSource" },
            { title: "EXCEPTION PROCEDURE", dataKey: "exceptionProcedure" },
        ];

        // Generate table
        doc.autoTable({
            head: [columns],
            body: dataToExport,
            startY: 30,
            tableWidth: 'auto', // Auto-adjust table to fit page
            styles: {
                fontSize: 8,
                cellPadding: 2,
                overflow: 'linebreak',
            },
            headStyles: {
                fillColor: [22, 160, 133],
                textColor: [255, 255, 255],
                halign: 'start',
            },
        });

        // Save PDF
        doc.save('activity_log.pdf');
    };

    const handleDownloadWord = () => {
        if (!getExceptionLoggingData || getExceptionLoggingData.length === 0) {
            console.error("No data available for export.");
            alert("No data to export!");
            return;
        }

        // Prepare data to be added to the Word document
        const dataToExport = getExceptionLoggingData.map(item => [
            String(item?.ExceptionSeverity || "NA"),  // Explicitly convert to string
            String(item?.ExceptionDate || "NA"),  // Explicitly convert to string
            String(item?.ExceptionMessage || "NA"),  // Explicitly convert to string
            String(item?.ExceptionSource || "NA"),  // Explicitly convert to string
            String(item?.ExceptionProcedure || "NA"),  // Explicitly convert to string
        ]);

        // Define the headers for the table in the Word document
        const headers = [
            "EXCEPTION SEVERITY", "EXCEPTION DATE", "EXCEPTION MESSAGE", "EXCEPTION SOURCE", "EXCEPTION PROCEDURE",
        ];

        // Create table rows for the document
        const tableRows = [
            // Header Row
            new TableRow({
                children: headers.map(header => new TableCell({ children: [new Paragraph(header)] }))
            }),
            // Data Rows
            ...dataToExport.map(row =>
                new TableRow({
                    children: row.map(cell => new TableCell({ children: [new Paragraph(cell)] }))
                })
            ),
        ];

        // Create the table
        const table = new Table({
            rows: tableRows
        });

        // Create the document with metadata
        const doc = new Document({
            creator: "Activity Trial System",
            title: "Exception Log Report",
            description: "A detailed report of Exception Log.",
            sections: [  // Ensure that sections are properly passed as an array
                {
                    children: [table]
                }
            ]
        });

        // Generate and download the Word document
        Packer.toBlob(doc)
            .then(blob => saveAs(blob, "exception_Log.docx"))
            .catch(error => {
                console.error("Error generating Word document:", error);
                alert("An error occurred while generating the Word document. Check the console for details.");
            });
    };

    const handlePrint = () => {
        if (!getExceptionLoggingData || getExceptionLoggingData.length === 0) {
            console.error("No data available for printing.");
            alert("No data to print!");
            return;
        }

        // Prepare data to be added to the table
        const dataToExport = getExceptionLoggingData.map(item => [
            item.ExceptionSeverity || "NA",
            item.ExceptionDate || "NA",
            item.ExceptionMessage || "NA",
            item.ExceptionSource || "NA",
            item.ExceptionProcedure || "NA",
        ]);

        // Define the headers for the table in the printable version
        const headers = [
            "EXCEPTION SEVERITY", "EXCEPTION DATE", "EXCEPTION MESSAGE", "EXCEPTION SOURCE", "EXCEPTION PROCEDURE"
        ];

        // Create HTML table with better styling
        let tableHtml = `
            <style>
                body { font-family: Arial, sans-serif; margin: 20px; }
                table { width: 100%; border-collapse: collapse; }
                th, td { 
                    border: 1px solid #ddd; 
                    padding: 8px; 
                    text-align: left;
                    vertical-align: top; /* Ensure text aligns properly */
                    max-width: 250px; /* Set max-width to prevent overflow */
                    word-break: break-word; /* Wrap long text */
                    white-space: normal; /* Allow multi-line text */
                }
                th { background-color: #f2f2f2; }
            </style>
            <h1>Exception Log Report</h1>
            <table>
                <thead>
                    <tr>
                        ${headers.map(header => `<th>${header}</th>`).join('')}
                    </tr>
                </thead>
                <tbody>
                    ${dataToExport.map(row => `
                        <tr>
                            ${row.map(cell => `<td>${cell}</td>`).join('')}
                        </tr>
                    `).join('')}
                </tbody>
            </table>
        `;

        // Create a print window
        const printWindow = window.open('', '', 'width=900,height=700');
        printWindow.document.write('<html><head><title>Exception Log Report</title></head><body>');
        printWindow.document.write(tableHtml);
        printWindow.document.write('</body></html>');
        printWindow.document.close();

        // Wait for content to load before triggering print
        setTimeout(() => {
            printWindow.print();
            printWindow.close();
        }, 500);
    };

    const processedExceptionLogData = useMemo(() => {
        return getExceptionLoggingData.map(item => ({
            ...item,
            ExceptionDate: String(formatDate(item.ExceptionDate || 'N/A')),
            ExceptionMessage: String(item.ExceptionMessage || 'N/A'),
            ExceptionSource: String(item.ExceptionSource || 'N/A'),
        }));
    }, [getExceptionLoggingData]);

    return (
        <div className="customer-management-container">
            <Main>
                <div className='components-download-container'>
                    <Download
                        showDashboardLibraryButton={false}
                        showSaveCustomViewButton={false}
                        showAnalyticsButton={false}
                        showDownloadDropdown={true}
                        onImageClick={handleDownloadImage}
                        onPdfDownloadClick={handleDownloadPDF}
                        onWordDownloadClick={handleDownloadWord}
                        onPrintClick={handlePrint}
                        onExcelDownloadClick={handleDownloadExcel}
                    />
                </div>
                <div className="customermanagement-content-container">
                    <div className="customermanagement-content">
                        <Row className='customermanagement-btns-container'>
                            <Col md={2} className='customermanagement-backbtn-div'>
                                {/* <img src={backbtn} alt="" /> */}
                                <span>Exception Log</span>
                            </Col>
                            <Col md={10} className='customermanagement-search-filter'>
                                <Col md={4} className='filters-col'>
                                    <div className='customermanagement-search'>
                                        {/* <Form.Control type="search" placeholder='Search' /> */}
                                        <Typeahead
                                            id="search-typeahead"
                                            className='typeahead-search'
                                            onChange={handleSearchChange}
                                            // options={[...new Set(complainEscalationData.map(complaint => complaint.AssignedToUser))]}
                                            options={processedExceptionLogData}
                                            labelKey="ExceptionDate" // We are using a string (the company name), so we just use the string directly
                                            filterBy={['ExceptionDate', 'ExceptionMessage', 'ExceptionSource']}
                                            placeholder="Search Exception Log"
                                            value={searchText}
                                            selected={selected}
                                            onInputChange={(input) => setSearchText(input)} // Update searchText with typed value
                                            minLength={1} // Minimum characters before suggestions appear
                                            autoFocus={false} // Prevent auto focusing on input
                                            renderMenu={(results, menuProps) => {
                                                // ✅ Hide table if an item is selected
                                                if (selected.length > 0 || !results.length) {
                                                    return null;
                                                }

                                                return (
                                                    <div {...menuProps} className='typeahead-search-options-table'>
                                                        <table className="table table-sm  mb-0">
                                                            <thead className="thead-light">
                                                                <tr>
                                                                    <th style={{ 'minWidth': '180px' }}>Exception Date</th>
                                                                    <th style={{ 'minWidth': '180px' }}>Exception Message</th>
                                                                    <th style={{ 'minWidth': '200px' }}>Exception Source</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {results.map((option, index) => (
                                                                    <tr key={option.ActivityLogID} onClick={() => handleSearchChange([option])} style={{ cursor: 'pointer' }}>
                                                                        <td><Highlighter search={searchText}>{option.ExceptionDate}</Highlighter></td>
                                                                        <td><Highlighter search={searchText}>{option.ExceptionMessage}</Highlighter></td>
                                                                        <td><Highlighter search={searchText}>{option.ExceptionSource}</Highlighter></td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                );
                                            }}
                                        />
                                        {/* <img src={searchIcon} alt="" className='p-2' onClick={handleSearchClick} /> */}
                                    </div>
                                </Col>
                                {/* <Col md={2} className='filters-col'> */}
                                {/* <Select
                                    className="react-select-container complaint-status-select"
                                    classNamePrefix="react-select"
                                    placeholder="Select Modules"
                                    // options={statusOptions}
                                    style={{ width: "100%" }}
                                /> */}
                                {/* </Col> */}
                                <Col md={2} className='filters-col'>
                                    <div className='calendar-container'>
                                        <DatePicker
                                            className="select from-date"
                                            id="date-range-picker"
                                            dateFormat="dd/MM/yyyy"
                                            // selectsRange
                                            placeholderText='From'
                                            selected={fromDate}
                                            onChange={(date) => setFromDate(date)}
                                            maxDate={new Date()}
                                            onChangeRaw={e => e.preventDefault()}
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                        />
                                        <img src={calendar} alt="" />
                                    </div>
                                </Col>
                                <Col md={2} className='filters-col'>
                                    <div className='calendar-container'>
                                        <DatePicker
                                            className="select from-date"
                                            id="date-range-picker"
                                            dateFormat="dd/MM/yyyy"
                                            // selectsRange
                                            placeholderText='To'
                                            selected={toDate}
                                            onChange={(date) => setToDate(date)}
                                            // maxDate={new Date()}
                                            onChangeRaw={e => e.preventDefault()}
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                        />
                                        <img src={calendar} alt="" />
                                    </div>
                                </Col>
                                <SbCancelBtn btnName="Clear" onClickEffect={handleClearFilters} />
                            </Col>
                        </Row>
                        <div className='customermanagement-table-div'>
                            <ExceptionLogTable
                                handleOpenModal={handleOpenModal}
                                handleViewDetails={handleViewDetails}
                                getExceptionLoggingData={getExceptionLoggingData}
                                loading={loading}
                                exceptionID={exceptionID}
                            />
                        </div>
                    </div>
                </div>
            </Main>
            {
                isModalOpen && <ViewExceptionModal
                    open={isModalOpen}
                    handleCloseModal={handleCloseModal}
                    getSingleExceptionLoggingData={getSingleExceptionLoggingData}
                />
            }
            {/* {showColumnFilterModal && (
                <CustomerFilterModal
                    showColumnFilterModal={showColumnFilterModal}
                    handleCloseColumnFilterModal={handleCloseColumnFilterModal}
                />
            )}
            {showValueFilterModal && (
                <CustomerValueFilterModal
                    showValueFilterModal={showValueFilterModal}
                    handleCloseValueFilterModal={handleCloseValueFilterModal}
                />
            )}
            {showCustomerViewDetails && (
                <CustomerViewDetails
                    showCustomerViewDetails={showCustomerViewDetails}
                    handleCloseViewDetails={handleCloseViewDetails}
                />
            )} */}
        </div >
    );
};

export default ExceptionLog;